export default __webpack_public_path__ + "static/media/mosaic-logo-icon-black.7d734486.svg";